import schema from './schema';
import icons from './icons';

import { toggleMark } from 'prosemirror-commands';
import { LinkButton } from './components/Link/LinkButton';
import { ImageButton } from './components/Image/ImageButton';

import {
  isMarkActive,
  isBlockActive,
  toggleUnorderedList,
  toggleOrderedList,
  canInsert,
} from './utils';
import { EmojiButton } from './components/Emoji/Emoji';

export default {
  marks: {
    strong: {
      title: 'Toggle strong',
      content: icons.strong,
      active: isMarkActive(schema.marks.strong),
      run: toggleMark(schema.marks.strong),
    },
    em: {
      title: 'Toggle emphasis',
      content: icons.em,
      active: isMarkActive(schema.marks.em),
      run: toggleMark(schema.marks.em),
    },
    underline: {
      title: 'Toggle underline',
      content: icons.underline,
      active: isMarkActive(schema.marks.underline),
      run: toggleMark(schema.marks.underline),
    },
    strikethrough: {
      title: 'Toggle strikethrough',
      content: icons.strikethrough,
      active: isMarkActive(schema.marks.strikethrough),
      run: toggleMark(schema.marks.strikethrough),
    },
  },
  insert: {
    // temporary disable, provide support later
    // file: {
    //   title: 'Add file',
    //   content: icons.file,
    //   component: AttachmentButton,
    //   run: () => true,
    // },
    emoji: {
      title: 'Add file',
      content: icons.emoji,
      component: EmojiButton,
      run: () => true, // currently handled inside component, consider moving here
    },
    link: {
      title: 'Add or remove link',
      content: icons.link,
      active: isMarkActive(schema.marks.link),
      component: LinkButton,
      run: () => true, // currently handled inside component, consider moving here
    },
    bullet_list: {
      title: 'Wrap in bullet list',
      content: icons.bullet_list,
      active: isBlockActive(schema.nodes.bullet_list),
      run: toggleUnorderedList,
    },
    ordered_list: {
      title: 'Wrap in ordered list',
      content: icons.ordered_list,
      active: isBlockActive(schema.nodes.ordered_list),
      run: toggleOrderedList,
    },
    image: {
      title: 'Insert image',
      content: icons.image,
      enable: canInsert(schema.nodes.image),
      active: isBlockActive(schema.nodes.image),
      component: ImageButton,
      run: () => true, // currently handled inside component, consider moving here
    },
  },
};
